<template>
    <div>
        <v-toolbar dense color="primary" app :clipped-left="true" dark tabs>
            <v-btn icon @click="goBack()">
                <v-icon>arrow_back</v-icon>
            </v-btn>
            <v-toolbar-title>Cadastrar PacPon</v-toolbar-title>
        </v-toolbar>

        <main>
            <v-container fluid>
                <v-layout wrap>
                    <v-flex xs12>
                        <v-list-tile-sub-title>CTO</v-list-tile-sub-title>
                        <v-select
                                hide-details
                                :items="all_caixas"
                                v-model="caixa.cto._id"
                                item-text="nome"
                                item-value="_id"
                                single-line
                        />
                    </v-flex>

                    <v-flex xs12>
                        <v-textarea
                                name="input-7-2"
                                label="OBS"
                                v-model="caixa.obs"
                                rows="4"
                                class="input-group--focused"
                        />
                    </v-flex>

                    <v-flex xs12>
                        <v-btn block :disabled="!caixa.cto._id" color="info" @click.stop="done()">
                            CADASTRAR PACPON
                        </v-btn>
                    </v-flex>
                </v-layout>
            </v-container>
        </main>
    </div>
</template>

<script>
    import { Caixas } from "../../class/caixas"

    export default {
        name: "CadastrarCaixa2",
        data () {
            return {
                all_caixas: [],
                obs: null,
                caixa: {
                    cto: {
                        _id: null
                    },
                    place: [0, 0]
                }
            }
        },
        beforeMount () {
            this.caixa.place[0] = Number(this.$route.params.lng);
            this.caixa.place[1] = Number(this.$route.params.lat);
            this.loadCaixasByPon();
        },
        methods: {
            loadCaixasByPon () {
                Caixas
                    .ctos()
                    .then(res => {
                        this.all_caixas = res.data;
                    })
                    .catch((err) => console.error(err))
            },
            goBack: function () {
                this.$router.push("/cadastrar/caixa");
            },
            done: async function () {
                let res = await Caixas.addPacPon(this.caixa);
                console.log(res.data);
                alert("Caixa Cadastrada!");
                this.$router.push("/onus-unregistered");
            }
        }
    }
</script>

<style scoped>

</style>
